export function getToken(){
    return $('#_token-csrf').html();
}


// WEBPACK FOOTER //
// ./js/libs/getToken.js